import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";
import { EmptyState } from "../EmptyState";
import { CATEGORY_COLORS } from "../../constants/constants";

export function categoryColorMap(data) {
  const map = {};
  data.forEach((d, i) => (map[d.label] = CATEGORY_COLORS[i % CATEGORY_COLORS.length]));
  return map;
}

export function DonutChart({
  data,
  colors,
  total,
  centerLabel,
  onSliceClick,
  activeKey,
  dataKeyLabel = "label",
}) {
  if (!data?.length) return <EmptyState />;

  return (
    <div className="w-full h-full min-w-0">
      <ResponsiveContainer
        width="100%"
        height="100%"
        minWidth={0}
        minHeight={220}
      >
        <PieChart>
          <Pie
            data={data}
            dataKey="count"
            nameKey={dataKeyLabel}
            cx="50%"
            cy="50%"
            innerRadius="55%"
            outerRadius="78%"
            paddingAngle={2}
            cornerRadius={3}
            stroke="none"
            onClick={(entry) =>
              onSliceClick &&
              onSliceClick(entry[dataKeyLabel])
            }
            cursor={onSliceClick ? "pointer" : "default"}
          >
            {data.map((entry) => (
              <Cell
                key={entry[dataKeyLabel]}
                fill={
                  colors[entry[dataKeyLabel]] || "#CBD5E1"
                }
                opacity={
                  activeKey &&
                  activeKey !== "ALL" &&
                  activeKey !== entry[dataKeyLabel]
                    ? 0.28
                    : 1
                }
              />
            ))}
          </Pie>

          <Tooltip
            contentStyle={{
              borderRadius: 10,
              border: "1px solid #E2E8F0",
              fontSize: 12,
            }}
            formatter={(value, name, props) => [
              `${value} (${props.payload.percentage}%)`,
              props.payload[dataKeyLabel],
            ]}
          />

          <text
            x="50%"
            y="48%"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-slate-900 text-xl font-semibold"
          >
            {total}
          </text>

          <text
            x="50%"
            y="58%"
            textAnchor="middle"
            dominantBaseline="middle"
            className="fill-slate-500 text-xs"
          >
            {centerLabel}
          </text>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}

export function DonutLegend({ data, colors, onSelect, activeKey, dataKeyLabel = "label" }) {
  return (
    <div className="flex flex-col gap-2 justify-center text-xs">
      {data.map((d) => (
        <button
          key={d[dataKeyLabel]}
          onClick={() => onSelect && onSelect(d[dataKeyLabel])}
          className={`flex items-center gap-2 group ${onSelect ? "cursor-pointer" : "cursor-default"}`}
        >
          <span
            className="w-2.5 h-2.5 rounded-full shrink-0"
            style={{ background: colors[d[dataKeyLabel]] || "#CBD5E1" }}
          />
          <span
            className={`flex-1 text-left truncate ${
              activeKey === d[dataKeyLabel] ? "text-slate-900 font-semibold" : "text-slate-500 group-hover:text-slate-700"
            }`}
          >
            {d[dataKeyLabel]}
          </span>
          <span className="font-semibold text-slate-700 w-7 text-right">{d.count}</span>
          <span className="text-slate-400 w-11 text-right">{d.percentage}%</span>
        </button>
      ))}
    </div>
  );
}